import {toISODate, toInt} from "../../../../utils/convert-fields"
import {formatDateBr} from "../../../../utils/convert-fields"

export const premioFields = [
    {"key": "IDPremio", "label": "ID Prêmio"},
    {"key": "IDEventoPremio", "label": "ID Evento Prêmio"},
    {"key": "DataReferencia", "label": "Data Referência"},
    {"key": "DataPremio", "label": "Data Premio"},
    {"key": "ValorPremio", "label": "Valor Prêmio"},
    {"key": "TipoPremio", "label": "Tipo Prêmio"},
    {"key": "CalculoPremio", "label": "Cálculo Prêmio"},
    {"key": "CasasPremio", "label": "Casas Prêmio"},
]

export const mapPremioPayload = (
    tableData = [],
    idCaracteristica
) => {
    const premios = tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map((column) => ({
            RendaFixaCaracteristicasID: idCaracteristica,
            IDPremio: toInt(column.IDPremio) ?? null,
            DataReferencia: toISODate(column.DataReferencia),
            DataPremio: toISODate(column.DataPremio),
            ValorPremio: column.ValorPremio ?? "",
            IDEventoPremio: column.IDEventoPremio ?? "",
            TipoPremio: column.TipoPremio ?? "",
            CalculoPremio: column.CalculoPremio ?? "",
            CasasPremio: column.CasasPremio ?? "",
        }))

    return {
        Premios: premios,
    }
}

export const mapPremioToTable = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        CETIP: item.CETIP || "",
        VersaoDocumento: item.VersaoDocumento ?? "",
        ID: item.ID,
        IDEventoPremio: item.IDEventoPremio ?? "",
        DataReferencia: item.DataReferencia ? formatDateBr(item.DataReferencia) : "",
        DataPremio: item.DataPremio ? formatDateBr(item.DataPremio) : "",
        ValorPremio: item.ValorPremio ?? "",
        TipoPremio: item.TipoPremio ?? "",
        IDPremio: item.IDPremio ?? "",
        CalculoPremio: item.CalculoPremio ?? "",
        CasasPremio: item.CasasPremio ?? "",
    }))
}